import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
  Button,
  Link,
} from "@mui/material";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import { Link as RouterLink } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function RegistrationLayout() {
  const [kyc, setKyc] = useState("low");
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const navigate = useNavigate();
  const verifymobile = () => {
    navigate("/registration/lowkyc");
  };

  return (
    <>
      <Box sx={{ minHeight: "100vh", bgcolor: "#f6f8f7" }}>
        {/* Header */}
        <Header />

        {/* Main Card */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <Card sx={{ width: "70%", p: 5, borderRadius: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h5" fontWeight="bold">
                Registration
              </Typography>
              <Link
                component={RouterLink}
                to="/"
                sx={{
                  color: "#2f7d43",
                  cursor: "pointer",
                  fontWeight: 500,
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                Back to Login
              </Link>
            </Box>

            {/* KYC Selection */}
            <RadioGroup
              row
              value={kyc}
              onChange={(e) => {
                const selected = e.target.value;

                if (selected === "full") {
                  setComingSoonOpen(true); // open dialog
                  return; // do not change KYC yet
                }

                setKyc(selected);
              }}
              sx={{ mt: 3 }}
            >
              <FormControlLabel
                value="low"
                control={<Radio color="success" />}
                label="Low KYC"
              />

              <FormControlLabel
                value="full"
                control={<Radio color="success" />}
                label="Full KYC"
              />
            </RadioGroup>

            {/* Limits Box */}
            <Box
              sx={{
                bgcolor: "#e9f7df",
                p: 3,
                borderRadius: 2,
                mt: 2,
                fontSize: 14,
              }}
            >
              <Typography fontWeight="bold" mb={1}>
                Please find below the limits for TA Wallet Low KYC A/C.
              </Typography>

              <ol style={{ paddingLeft: 20 }}>
                <li>
                  Wallet balance cannot exceed Rs 10,000/- at any point of time.
                </li>
                <li>Load Money maximum of Rs 10,000/- per month.</li>
                <li>Fund transfer to other wallet A/C - Not allowed.</li>
                <li>Fund transfer to bank A/C (IMPS) - Not allowed.</li>
                <li>Load Money only through Net Banking, UPI, NEFT & IMPS.</li>
                <li>Using Credit and Debit card is not allowed.</li>
                <li>Gift Vouchers - Not allowed.</li>
                <li>Rupay Card - Not allowed.</li>
                <li>
                  Payments are not allowed for 48 hours after wallet opening.
                </li>
              </ol>
            </Box>

            {/* Agreements */}
            <Box sx={{ mt: 3 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={agree1}
                    onChange={() => setAgree1(!agree1)}
                    color="success"
                  />
                }
                label="I hereby declare that my age is 18 years or more."
              />

              <FormControlLabel
                control={
                  <Checkbox
                    checked={agree2}
                    onChange={() => setAgree2(!agree2)}
                    color="success"
                  />
                }
                label={
                  <>
                    I agree that I have read and understood the terms &
                    conditions of TA Wallet
                  </>
                }
              />
            </Box>

            {/* Proceed Button */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <Button
                variant="contained"
                disabled={!(agree1 && agree2)}
                sx={{
                  bgcolor: "#2f7d43",
                  px: 6,
                  color: "white",
                  py: 1.2,
                  borderRadius: 2,
                  "&:hover": { bgcolor: "#256836" },
                }}
                onClick={verifymobile}
              >
                Proceed now
              </Button>
            </Box>
          </Card>
        </Box>

        {/* Footer */}
        <Footer />
      </Box>
      <Dialog
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        PaperProps={{
          sx: { borderRadius: 3, p: 1, minWidth: 320 },
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          🚧 Coming Soon
        </DialogTitle>

        <DialogContent sx={{ textAlign: "center", py: 2 }}>
          <Typography>
            Full KYC registration will be available very soon.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#2f7d43",
              px: 4,
              "&:hover": { bgcolor: "#256836" },
              color: "white",
            }}
            onClick={() => setComingSoonOpen(false)}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
